import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { getIconComponent } from '../../utils/iconHelper';
import { getArray, getArrayLength, isTruthy } from '../../utils/helpers';
import { getSocialMedia } from '../../provider/SocialMedia';
import pages from '../../subscriber/Pages';

const SocialMedia = ({isInline = false}) => {
    const [hydrated, setHydrated] = useState(false);
    const { social_media } = pages || {};
    
    useEffect(() => {
        setHydrated(true);
        if (getArrayLength(social_media) === 0) {
            getSocialMedia();
        }
    }, [social_media]);

    if (!hydrated || getArrayLength(social_media) === 0) return null;

    const SocialIcon = ({ Icon, link = "#" }) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-[#C7702A] text-accent hover:text-accent-dark flex items-center" >
            <Icon size={20} className='my-2' />
        </a>
    );

    if (isTruthy(isInline)) {
        return (
            <div className="flex justify-center space-x-4">
                {getArray(social_media).map((link, index) => {
                    const IconComponent = getIconComponent(link.key);
                    return (
                        IconComponent && <SocialIcon key={index} Icon={IconComponent} link={link.value} />
                    );
                })}
            </div>
        )
    }

    return (
        <aside className="w-full md:w-1/12 px-4 hidden md:block">
            <div className="sticky top-20">
                <div className="flex flex-col space-y-4">
                    {getArray(social_media).map((link, index) => {
                        const IconComponent = getIconComponent(link.key);
                        return (
                            IconComponent && <SocialIcon key={index} Icon={IconComponent} link={link.value} />
                        );
                    })}
                </div>
            </div>
        </aside>
    )
}

export default observer(SocialMedia);